import React, {useState, useEffect} from "react";
import {autorun} from "mobx";
import {AppState, BotStatusData} from "../../../../../../app/types";
import {DashboardState} from "../../types";
import {Button, Menu, MenuItem, Tooltip} from "@material-ui/core";
import {getBotsState} from "../../../../../botsControl/logic/getBotsState";

export const RegionsMenu = (p: {appState: AppState; dashState: DashboardState}) => {
    const {appState} = p;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [region, setSelectedRegion] = useState(p.dashState.data.region);
    // console.log("gateway:" + p.dashState.data.gateway);
    let regions = [] as string[];
    const botsState = getBotsState(appState);
    const bot = appState.data.bots_statuses.find(bot => bot.key === botsState.expandedBotId);

    useEffect(() => {
        return autorun(() => (p.dashState.data.region = region));
    }, [region]);

    if (!bot) return null;
    const configData = (bot.configData || {}) as any;
    const cRegions = (configData.dashRegions || "") as string;
    regions = cRegions == "" ? [] : cRegions.split(",");
    // if (platforms.length > 0 && !platform) {
    //     setSelected(platforms[0]);
    // }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    return regions.length > 0 ? (
        <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
            <Tooltip title="Regions">
                <Button onClick={handleClick}>{!region ? "ALL" : region}</Button>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                {regions.map((name, i) => {
                    return (
                        <MenuItem
                            key={`name ${i}`}
                            value={name}
                            onClick={() => {
                                setSelectedRegion(name);
                                handleClose();
                            }}>
                            {name}
                        </MenuItem>
                    );
                })}
            </Menu>
        </div>
    ) : null;
};
